import { Box, Flex, Text, HStack, VStack, Divider } from "@chakra-ui/react";
import logo from "../assets/logo-white.png";
export default function Footer() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box
      bg="brand.black"
      borderTop="1px solid rgba(46,46,46,0.8)"
      pt={12}
      pb={8}
      px={{ base: 6, md: 12, lg: 20 }}
    >
      <Flex
        maxW="1400px"
        mx="auto"
        justify="space-between"
        align={{ base: "flex-start", md: "flex-end" }}
        wrap="wrap"
        gap={8}
        mb={10}
      >
        {/* Brand */}
        <Box>
         <img
              src={logo}
              alt="Logo"
              style={{ height: 40, marginRight: 10 }}
            />
          <Text
            fontSize="xs"
            color="rgba(245,240,235,0.35)"
            mt={3}
            maxW="220px"
            lineHeight="1.8"
          >
            The voice behind your next deal. Professional real estate outreach & lead generation.
          </Text>
        </Box>

        {/* Nav */}
        <VStack align={{ base: "flex-start", md: "flex-end" }} spacing={3}>
          {["home", "about", "contact"].map((id) => (
            <Text
              key={id}
              fontSize="xs"
              letterSpacing="0.2em"
              textTransform="uppercase"
              color="brand.muted"
              cursor="pointer"
              _hover={{ color: "brand.coral" }}
              transition="color 0.3s"
              onClick={() => scrollTo(id)}
            >
              {id}
            </Text>
          ))}
        </VStack>

        {/* Contact */}
        <VStack align={{ base: "flex-start", md: "flex-end" }} spacing={3}>
          <Text fontSize="xs" color="rgba(245,240,235,0.45)" letterSpacing="0.1em">
            98 8th Avenue, Edenvale, Johannesburg
          </Text>
          <Text fontSize="xs" color="rgba(245,240,235,0.45)" letterSpacing="0.1em">
            info@reliabletouchservices.co.za
          </Text>
          <Text fontSize="xs" color="rgba(245,240,235,0.45)" letterSpacing="0.1em">
            063 956 8901 | 076 343 7491
          </Text>
          <Text fontSize="xs" color="rgba(245,240,235,0.45)" letterSpacing="0.1em">
            @reliable_touch
          </Text>
          <Text fontSize="xs" color="rgba(245,240,235,0.45)" letterSpacing="0.1em">
            Mon–Fri, 08:00 – 18:00
          </Text>
        </VStack>
      </Flex>

      <Divider borderColor="rgba(46,46,46,0.6)" />

      <Flex
        maxW="1400px"
        mx="auto"
        justify="space-between"
        align="center"
        pt={6}
        wrap="wrap"
        gap={3}
      >
        <Text fontSize="xs" color="brand.muted" letterSpacing="0.1em">
          © 2025 Reliable Touch Services. All rights reserved.
        </Text>
        <Text fontSize="xs" color="brand.muted" letterSpacing="0.1em">
          Real Estate Lead Generation · South Africa
        </Text>
      </Flex>
    </Box>
  );
}
